/**
 * File Upload Component
 * Handles file uploads with drag-and-drop support
 */

import { useRef, useState } from 'react';
import { StyledDropContent, StyledDropIcon, StyledDropSubtext, StyledDropText, StyledDropZone, StyledFileUploadContainer, StyledHiddenInput, StyledProgressBarContainer, StyledProgressBarFill, StyledUploadingContent, StyledUploadingText } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function FileUpload({
  onUpload,
  isUploading,
  uploadProgress,
  currentPath,
  maxFileSizeLabel
}) {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  function handleDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }
  function handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }
  function handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    if (droppedFiles.length > 0 && !isUploading) {
      onUpload(droppedFiles);
    }
  }
  function handleFileInputChange(e) {
    const selectedFiles = Array.from(e.target.files || []);
    if (selectedFiles.length > 0) {
      onUpload(selectedFiles);
    }
    // Reset input so same file can be selected again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }
  function handleClick() {
    if (!isUploading && fileInputRef.current) {
      fileInputRef.current.click();
    }
  }
  return _jsx(StyledFileUploadContainer, {
    children: _jsxs(StyledDropZone, {
      isDragging: isDragging,
      isUploading: isUploading,
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDragOver: handleDragOver,
      onDrop: handleDrop,
      onClick: handleClick,
      children: [_jsx(StyledHiddenInput, {
        ref: fileInputRef,
        type: "file",
        multiple: true,
        onChange: handleFileInputChange,
        disabled: isUploading
      }), isUploading ? _jsxs(StyledUploadingContent, {
        children: [_jsx(StyledProgressBarContainer, {
          children: _jsx(StyledProgressBarFill, {
            progress: uploadProgress
          })
        }), _jsxs(StyledUploadingText, {
          children: ["Uploading... ", uploadProgress, "%"]
        })]
      }) : _jsxs(StyledDropContent, {
        children: [_jsx(StyledDropIcon, {
          children: "\uD83D\uDCE4"
        }), _jsx(StyledDropText, {
          children: "Drag files here or click to upload"
        }), _jsxs(StyledDropSubtext, {
          children: ["Uploading to: ", currentPath, maxFileSizeLabel ? ` (max ${maxFileSizeLabel} per file)` : '']
        })]
      })]
    })
  });
}
export default FileUpload;